<script lang="ts" setup>
const props = withDefaults(defineProps<{ buttons?: Button[], background?: Theme, size?: string }>(), { size: '3xl' })
const displayButtons = ref<{ target: string, to: string, delay: number }[]>()
watch(() => props.buttons, (val) => {
  displayButtons.value = val?.map((button, index) => {
    return {
      target: getTarget(button),
      title: button.title,
      to: getUrl(button),
      color: getButtonColor(props.background),
      delay: 100 * (index + 1),
    }
  })
}, { immediate: true })

const color = ref<{ button: string, icon: string }>({ button: 'blue', icon: 'text-yellow' })

watch(() => props.background, () => {
  color.value = getButtonColor(props.background)
}, { immediate: true })

function getUrl(button: Button) {
  if (button?.expand?.page?.slug) {
    return `${button.expand.page.slug}`
  }
  return button?.href ?? '/'
}

function getTarget(button: Button) {
  if (button.href) {
    return '_blank'
  }
  return '_self'
}
</script>

<template>
  <div
    v-if="buttons && buttons.length"
    class="flex text-black gap-3 flex-wrap"
  >
    <template
      v-for="({ title, ...button }, index) in displayButtons"
      :key="button.id"
    >
      <UButton
        v-motion
        :visible="{ opacity: 1, y: 0, x: 0, scale: 1 }"
        :initial="{ opacity: 0, y: 10, x: 0, scale: 0.5 }"
        :size="size"
        trailing
        v-bind="button"
        :color="color?.button"
        :ui="{ shadow: 'shadow-xl', base: 'inline-flex items-center overflow-clip' }"
      >
        <span class="relative">{{ title }}</span>
        <div class="relative inline-flex items-center justify-center z-[0]">
          <Icon
            name="gbf:arrow-right"
            :class="color.icon"
            class=" h-8 w-8 animate-side-ping group-hover:animate-pause"
          />
          <Icon
            name="gbf:arrow-right"
            :class="color.icon"
            class=" h-8 w-8 absolute opacity-0 group-hover:opacity-100 group-hover:animate-ping-lg inset-0"
          />
        </div>
      </UButton>
    </template>
  </div>
</template>

<style scoped></style>
